import './index.css';

import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import React from 'react';
import * as evrythng from 'evrythng';

import {
	Help,
	Home,
	Step1,
	Step1Help,
	Step2,
	Step2Help,
	VerificationResults,
	Step1Success,
} from './containers';
import { setEvrythngKey } from './apis/evrythng';
import GoogleTagManager from './components/GoogleTagManager';
import history from './history';
import store from './store';
import theme from './theme';

window.evrythng = evrythng;

function App() {
	window.evrythng.use(window.PubSub);
	window.PubSub.setup({ apiUrl: process.env.REACT_APP_EVERYTHNG_PUB_SUB_URL });

	const searchParams = new URLSearchParams(window.location.search);
	const apiKey = searchParams.get('token');

	if (apiKey) {
		setEvrythngKey(apiKey);
	}

	return (
		<ThemeProvider theme={theme}>
			<GoogleTagManager />
			<CssBaseline />
			<Provider store={store}>
				<ConnectedRouter history={history} forceRefresh={false}>
					<Switch>
						<Route path="/step1/help">
							<Step1Help />
						</Route>
						<Route path="/step1/success">
							<Step1Success />
						</Route>
						<Route path="/step2/help">
							<Step2Help />
						</Route>
						<Route exact path="/step1">
							<Step1 />
						</Route>
						<Route exact path="/step2">
							<Step2 />
						</Route>
						<Route path="/verificationResults/:results">
							<VerificationResults />
						</Route>
						<Route path="/verificationResults">
							<VerificationResults />
						</Route>
						<Route path="/help">
							<Help />
						</Route>
						<Route path="/">
							<Home />
						</Route>
					</Switch>
				</ConnectedRouter>
			</Provider>
		</ThemeProvider>
	);
}

export default App;
